export const arabicRegex =
  /^(?=.*[\u0600-\u06FF])[\u0600-\u06FF0-9\s!@#$%^&*(),.?":{}|<>_\-+=/\\[\]]+$/;

export const englishRegex =
  /^(?=.*[A-Za-z])[A-Za-z0-9\s!@#$%^&*(),.?'~`":;{}|<>_\-+=/\\[\]]+$/;
